module.exports = __webpack_public_path__ + "assets/images/arrow-inbound.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/arrow-inbound.png
// module id = 243
// module chunks = 1